<template>
  <div class="profile-container">
    <h1>
      <i class="fas fa-id-card"></i> {{ $t('profileInformation') }}
    </h1>

    <!-- Loading Indicator -->
    <div v-if="isLoading" class="loading">
      <p>{{ $t('admin.loading_message') }}</p>
    </div>

    <!-- Dados do usuário -->
    <div v-if="user && !isLoading" class="profile-details">
      <div class="detail-row">
        <strong><i class="fas fa-user"></i> {{ $t('fullName') }}</strong>
        <span>{{ user.nome || $t('notProvided') }} {{ user.sobrenome || $t('notProvided') }}</span>
      </div>
      <div class="detail-row">
        <strong><i class="fas fa-id-badge"></i> {{ $t('document') }}</strong>
        <span>
          <span class="document-type">{{ user.documento_tipo }}: </span>
          {{ user.documento }}
        </span>
      </div>
      <div class="detail-row">
        <div>
          <strong><i class="fas fa-envelope"></i> {{ $t('email') }}</strong>
          <p v-if="!user.email_verified_at" class="email-not-confirmed">{{ $t('emailNotConfirmed') }}</p>
        </div>
        <span>{{ user.email || $t('notProvided') }}</span>
        <div v-if="!user.email_verified_at" class="email-not-confirmed" style="max-width: 200px;">
          <a href="#" @click.prevent="reenviarEmail">
            <i class="fas fa-paper-plane"></i> {{ $t('resendEmail') }}
          </a>
          <LoaderSpinner :isLoading="isLoadingReSendEmail" />
          <br />
          <span>{{ resendEmailMessage }}</span>
        </div>
      </div>
      <div class="detail-row">
        <strong><i class="fas fa-passport"></i> {{ $t('foreigner') }}</strong>
        <span>{{ user.estrangeiro ? $t('yes') : $t('no') }}</span>
      </div>
      <div class="detail-row">
        <strong><i class="fas fa-phone"></i> {{ $t('phone') }}</strong>
        <span>{{ user.telefone || $t('notProvided') }}</span>
      </div>
      <div class="detail-row">
        <strong><i class="fas fa-clock"></i> {{ $t('lastLogin') }}</strong>
        <span>{{ formatDate(user.data_ultimo_login) || $t('notProvided') }}</span>
      </div>
    </div>

    <!-- Botão para editar perfil -->
    <div class="profile-actions">
      <button class="edit-btn" @click="showPerfilModal = true">
        <i class="fas fa-edit"></i> {{ $t('editProfile') }}
      </button>
    </div>

    <!-- Modal de edição -->
    <AlterarPerfilModal
      v-if="showPerfilModal"
      @close="showPerfilModal = false"
      @salvar="handlePerfilSalvo"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import LoaderSpinner from '../components/LoaderSpinner.vue';
import AlterarPerfilModal from './AlterarPerfilModal.vue';

export default {
  name: 'Profile',
  components: {
    LoaderSpinner,
    AlterarPerfilModal
  },
  data() {
    return {
      isLoading: false,
      isLoadingReSendEmail: false,
      resendEmailMessage: '',
      showPerfilModal: false
    };
  },
  computed: {
    user() {
      this.isLoading = !this.$store.getters['auth/getUser'];
      return this.$store.getters['auth/getUser'];
    },
    ...mapGetters(['getToken']),
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(date).toLocaleDateString('pt-BR', options);
    },
    reenviarEmail() {
      this.isLoadingReSendEmail = true;
      this.resendEmailMessage = '';
      const token = localStorage.getItem("token");
      axios.post(`${process.env.VUE_APP_API_URI}/ecom/cliente/reenviar-email`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(() => {
          this.resendEmailMessage = this.$t('verifyInbox');
        })
        .catch(error => {
          console.log("Erro ao tentar reenviar email de confirmação> ", error);
          this.resendEmailMessage = this.$t('verifyInboxError');
        })
        .finally(() => {
          this.isLoadingReSendEmail = false;
        });
    },
    handlePerfilSalvo(payload) {
      console.log('Dados do perfil salvos:', payload);
      // Aqui você pode chamar uma API para atualizar os dados do usuário
      this.showPerfilModal = false;
    }
  }
};
</script>

<style scoped>
.profile-container {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.profile-container h1 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 0.5rem;
}

.profile-details {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 0.8rem 0;
}

.detail-row strong {
  font-size: 1rem;
  color: #34495e;
}

.detail-row span {
  font-size: 0.95rem;
  color: #7f8c8d;
}

.email-not-confirmed {
  color: #e74c3c;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.email-not-confirmed a {
  color: #e74c3c;
  text-decoration: none;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.email-not-confirmed a:hover {
  text-decoration: underline;
}

.loading {
  text-align: center;
  color: #3498db;
  font-size: 1.5rem;
  margin-top: 2rem;
}

.profile-actions {
  margin-top: 2rem;
  text-align: right;
}

.edit-btn {
  padding: 0.6rem 1.2rem;
  background-color: #2980b9;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.edit-btn:hover {
  background-color: #3498db;
}

@media (max-width: 768px) {
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .profile-actions {
    text-align: center;
  }
}
</style>
